







import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import BankAccountTypeView from '@/modules/bank-account/components/shared/BankAccountTypeView.vue'
import { InjectReactive } from 'vue-property-decorator'
import ShebaView from '@/modules/shared/components/shared/ShebaView.vue'
import AdminDepositBankAccountStatusView
  from '@/modules/deposit-bank-account/components/admin/AdminDepositBankAccountStatusView.vue'
import QIcon from 'quasar/src/components/icon/QIcon.js';
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import AdminDepositBankAccountIndexPageTableActions
  from '@/modules/deposit-bank-account/components/admin/table/AdminDepositBankAccountIndexPageTableActions.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminDepositBankAccountIndexPageTableRow extends mixins(TesTableRow) {
  @InjectReactive() fixedData

  columnComponents = {
    title: {
      component: TextEllipsis,
      handler: value => ({ text: value })
    },
    account_type: {
      component: BankAccountTypeView,
      handler: (value, row, fixedData) => ({ type: value, types: fixedData.accountTypes })
    },
    account_owner_name: {
      component: TextEllipsis,
      handler: value => ({ text: value })
    },
    sheba: {
      component: ShebaView,
      handler: value => ({ model: value, mask: true })
    },
    status: {
      component: AdminDepositBankAccountStatusView,
      handler: (value, row, fixedData) => ({ status: value, statusesInPersian: fixedData.statuses })
    },
    default: {
      component: QIcon,
      handler: value => ({
        class: value ? 'text-tes-green' : 'invisible',
        name: 'ion checkmark-circle',
        size: 'md'
      })
    },
    actions: {
      component: AdminDepositBankAccountIndexPageTableActions,
      handler: (_, row) => ({ accountId: row.id })
    }
  }
}
